// extracted by mini-css-extract-plugin
module.exports = {"container":"classes_container__rXAcH","personal":"classes_personal__1QOZg","name":"classes_name__1wnX4","skills":"classes_skills__smC0K"};